import { DESCRIPTION_COPY_LIMITS } from "../copy-policy";
import { BLOCK_BACKGROUND_PALETTE_KEY, BLOCK_BACKGROUND_PALETTE_SLOT, } from "../background-palette";
export const videoSchema = {
    componentId: "Video",
    scalarSlots: [
        // The KEY names the role — it is what reaches the component's `playLabel`
        // prop — while the LABEL is what an Editor reads. They differ deliberately:
        // the repo owner asked for the field to be called a description of the film,
        // which is what an Editor is actually writing, while the role it plays is
        // naming the control. Recorded in compose-video.dsl-inventory.md.
        {
            key: "playLabel",
            ...DESCRIPTION_COPY_LIMITS,
            label: "Description of the video",
            type: "text",
        },
        BLOCK_BACKGROUND_PALETTE_SLOT,
    ],
    mediaSlots: [
        {
            key: "media",
            label: "Video",
            // THE FIRST VIDEO-ONLY SLOT IN THE CATALOG. Every other slot takes
            // pictures, and two take either kind. A still image in a band whose whole
            // purpose is to be played would be a control that cannot act.
            accepts: ["video"],
            // UNFRAMED, and this is required rather than preferred. A video is never
            // cropped, so there is no output size — and `BlockMediaSlot` renders no
            // picker at all for a slot with neither `unframed` nor a target, which
            // would leave this slot unfillable. Declaring a nominal target instead
            // would impose a size floor on media that is never framed, print
            // picture-shaped guidance an Editor cannot act on, and add a phantom
            // dimension to every asset's crop-target list.
            //
            // The first BLOCK-LEVEL unframed slot, too: the only other two are
            // pictures-only slots inside repeat groups (carousel, resource cards).
            unframed: true,
            targets: [],
            // `playback` is deliberately ABSENT. It is read only by the shared media
            // view, which this band does not mount — it draws its own player — so a
            // declaration here would be a lever connected to nothing.
        },
    ],
    sections: [
        { key: "content", label: "Content", slotKeys: ["playLabel"] },
        {
            key: "appearance",
            label: "Appearance",
            slotKeys: [BLOCK_BACKGROUND_PALETTE_KEY],
        },
    ],
};
//# sourceMappingURL=video.js.map